import { render, staticRenderFns } from "./Retail2.vue?vue&type=template&id=08d3c047"
import script from "./Retail2.vue?vue&type=script&lang=js"
export * from "./Retail2.vue?vue&type=script&lang=js"
import style0 from "./Retail2.vue?vue&type=style&index=0&id=08d3c047&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports